import React, { useState, useRef } from 'react';
import {getBackgroundImg, getPublicImagePath, getUploadedImagePath, useAppState} from '@nutastic/nutastic-react-app';
import { ReactSVG } from 'react-svg';
import CategoryBox from '../CategoryBox';
import ShopCategoryPage from './ShopCategoryPage';
import PriceSheet from "../PriceSheet";

const HomePage = () => {
    const componentClass = 'home-page';
    const [activeCategory, setActiveCategory] = useState(null);
    const [shouldShowPrices, setShouldShowPrices] = useState(false);
    const { page = {}, categories = [] } = useAppState();
    const { field_1: welcomeTitle, field_2: welcomeSubtitle } = page;

    // Setup Slider Logic
    const sliderRef = useRef();
    const [sliderPos, setSliderPos] = useState(0);
    const numberOfVisibleSlides = 4;
    const maxNumberOfSliderClicks = categories.length - numberOfVisibleSlides;
    const useSlider = maxNumberOfSliderClicks > 0;
    const onSliderClick = (isReverse) => {
        const nextPos = isReverse ? sliderPos - 1 : sliderPos + 1;
        if (sliderRef && ((!isReverse && nextPos <= maxNumberOfSliderClicks) || (isReverse && nextPos >= 0))) {
            sliderRef.current.style.left = `${-25 * nextPos}%`;
            setSliderPos(nextPos);
        }
    };

    return <React.Fragment>
        <main className={`${componentClass}__container`}>
            <section className={`${componentClass}__mainRow`}> { /** TODO: make the banner-box only show when promo is activated */ }
                <div className={`${componentClass}__box banner-box animated fadeInLeft`} style={getBackgroundImg(getPublicImagePath('examples/banner.jpg'))}/>
                <div className={`${componentClass}__box title-box animated fadeInDown`}>
                    <ReactSVG src={getPublicImagePath('mVibes-logo.svg')} className={`${componentClass}__logo animated zoomIn delay-1s`} />
                    <h1>{ welcomeTitle }</h1>
                    <span>{ welcomeSubtitle }</span>
                </div>
            </section>
            <section className={`${componentClass}__navRow animated fadeInUp delay-1s`}>
                { useSlider && <div className="categoryButtons">
                    <i className={`ion-md-arrow-dropleft-circle ${sliderPos > 0 ? '' : 'disabled'} `} onClick={() => onSliderClick(true)} />
                    <i className={`ion-md-arrow-dropright-circle ${sliderPos < maxNumberOfSliderClicks ? '' : 'disabled'}`} onClick={() => onSliderClick(false)} />
                </div> }
                <div className={`categorySlider ${useSlider ? 'disabled' : ''}`} ref={sliderRef}>
                    {
                        (categories || []).map((cat, index) => {
                            const { id, title, image_1: image, field_1: subtitle } = cat;
                            const onBoxClick = () => setActiveCategory(categories.find(c => c.id === id));
                            return <CategoryBox
                                image={getUploadedImagePath(image)}
                                title={title}
                                subtitle={subtitle}
                                onClick={onBoxClick}
                                key={index}
                            />;
                        })
                    }
                </div>
            </section>
        </main>
        <ShopCategoryPage
            isOpen={activeCategory}
            onClose={() => setActiveCategory(false)}
            category={activeCategory || {}}
            onPriceSheetClick={() => setShouldShowPrices(true)}
        />
        <PriceSheet isActive={shouldShowPrices} onClose={() => setShouldShowPrices(false)} />
    </React.Fragment>;
};

export default HomePage;
